module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-2",
    attrs: {
      "id": "billNo"
    }
  }, [_c('label', {
    attrs: {
      "for": "billNo"
    }
  }, [_vm._v("Transfor No :")]), _vm._v(" "), _c('span', {
    staticClass: "purchaseOutput "
  }, [_c('b', [_vm._v(_vm._s(_vm.salesHeaderObj.transforNo))])])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "salesDate"
    }
  }, [_vm._v("Date :")]), _vm._v(" "), _c('span', {
    staticClass: "purchaseOutput"
  }, [_c('b', [_vm._v(_vm._s(_vm.salesHeaderObj.transforDate))])])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "WarehouseName"
    }
  }, [_vm._v("From Store :")]), _vm._v(" "), _c('span', {
    staticClass: "purchaseOutput "
  }, [_c('b', [_vm._v(_vm._s(_vm.salesHeaderObj.warehouseFromName) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "WarehouseName"
    }
  }, [_vm._v("To Store :")]), _vm._v(" "), _c('span', {
    staticClass: "purchaseOutput "
  }, [_c('b', [_vm._v(_vm._s(_vm.salesHeaderObj.warehouseToName) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  })]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered "
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.inventoryInOutDetailList), function(pd, index) {
    return _c('tbody', {
      key: index
    }, [_c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pd.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pd.quantity))])])])
  })], 2), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-7"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('b', {
    staticStyle: {
      "margin-left": "12em"
    }
  }, [_vm._v(_vm._s(_vm.totalQty))])])]), _vm._v(" "), _c('hr'), _vm._v(" "), (this.extraExpensesList.length > 0) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('h5', [_vm._v("Extra Expenses:")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered ",
    staticStyle: {
      "margin-top": "2%"
    }
  }, [_vm._m(2), _vm._v(" "), _vm._l((_vm.extraExpensesList), function(expenses, index) {
    return _c('tbody', {
      key: index
    }, [_c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(expenses.expensesName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(expenses.extraExpenseAmt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(expenses.applyVat))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(expenses.debitAccountName) + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(expenses.creditAccountName) + " ")])])])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-10"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1"
  }, [_c('Button', {
    staticClass: "p-button-raised",
    attrs: {
      "label": "Back"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.back()
      }
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("SN")]), _vm._v(" "), _c('th', [_vm._v("Item Name")]), _vm._v(" "), _c('th', [_vm._v("Quantity")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('b', {
    staticStyle: {
      "margin-left": "15em"
    }
  }, [_vm._v("Total:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("SN")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Amount")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Vatable")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Debit Account")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Credit Account")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d53d51b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/stockTransfer/stockTransforDetailStoreWise.vue
// module id = 2074
// module chunks = 0